module.exports = __webpack_public_path__ + "static/media/icon-arrow-d.ae9e578e.svg";